import { render, staticRenderFns } from "./WsExamGroupsList.vue?vue&type=template&id=79c3327c"
import script from "./WsExamGroupsList.vue?vue&type=script&lang=js"
export * from "./WsExamGroupsList.vue?vue&type=script&lang=js"
import style0 from "./WsExamGroupsList.vue?vue&type=style&index=0&id=79c3327c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports